import {Card, CardContent, CardMedia, CardProps, Stack, Typography} from "@mui/material";
import {BaseWorldDocument} from "../../../../types/pj1dbApiWorld";

export interface BaseWorldListItemProps extends CardProps {
  item: BaseWorldDocument;
  // eslint-disable-next-line react/require-default-props
  children?: React.ReactNode;
}

export function BaseWorldListItem({item, children, ...props}: BaseWorldListItemProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Card {...props} sx={{width: 240, ...props.sx}}>
      <CardMedia
        component="img"
        height="145"
        image={item.url?.thumbnail}
        alt={item.attr['name-jp']}
        sx={{objectFit: "scale-down"}}
      />
      <CardContent sx={{p: 1, m: 0, textWrap: 'nowrap', overflowX: 'scroll'}}>
        <Stack gap={1}>
          <Typography variant="subtitle2" component='p'>
            ベースワールド名：{item.attr['name-jp']}
          </Typography>
          {children}
        </Stack>
      </CardContent>
    </Card>
  )
}
